import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { cn } from "../lib/utils.js";
import { StickToBottom, useStickToBottomContext } from "use-stick-to-bottom";
const Conversation = ({ className, ...props }) => /* @__PURE__ */ jsx(
  StickToBottom,
  {
    className: cn("tw:relative tw:flex-1 tw:overflow-hidden", className),
    initial: "smooth",
    resize: "smooth",
    role: "log",
    ...props
  }
);
const ConversationContent = ({ className, ...props }) => /* @__PURE__ */ jsx(StickToBottom.Content, { className: cn("tw:p-4", className), ...props });
const ConversationEmptyState = ({
  className,
  title = "No messages yet",
  description = "Start a conversation to see messages here",
  icon,
  children,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "tw:flex tw:size-full tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:p-8 tw:text-center",
      className
    ),
    ...props,
    children: children ?? /* @__PURE__ */ jsxs(Fragment, { children: [
      icon && /* @__PURE__ */ jsx("div", { className: "tw:text-muted-foreground", children: icon }),
      /* @__PURE__ */ jsxs("div", { className: "tw:space-y-1", children: [
        /* @__PURE__ */ jsx("h3", { className: "tw:font-medium tw:text-sm", children: title }),
        description && /* @__PURE__ */ jsx("p", { className: "tw:text-muted-foreground tw:text-sm", children: description })
      ] })
    ] })
  }
);
const ConversationScrollButton = ({ className, ...props }) => {
  const { isAtBottom, scrollToBottom } = useStickToBottomContext();
  const handleScrollToBottom = useCallback(() => {
    scrollToBottom();
  }, [scrollToBottom]);
  if (isAtBottom) return null;
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: cn(
        "tw:absolute tw:bottom-4 tw:left-1/2 tw:-translate-x-1/2 tw:z-10 tw:hover:bg-[#DCDDDC] tw:transition-colors",
        className
      ),
      onClick: handleScrollToBottom,
      type: "button",
      "aria-label": "Scroll to bottom",
      style: {
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: "#FFFFFF",
        border: "1px solid #DCDDDC",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: 0
      },
      ...props,
      children: /* @__PURE__ */ jsx("svg", { width: "16", height: "16", viewBox: "0 0 9 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.63193 12.243C4.63209 12.2428 4.63234 12.2426 4.63252 12.2424L8.11923 8.73875C8.3804 8.47628 8.37946 8.05174 8.11695 7.79047C7.85448 7.52923 7.42992 7.53023 7.16871 7.79272L4.82777 10.145V0.670522C4.82777 0.300195 4.52759 0 4.15725 0C3.78692 0 3.48668 0.300195 3.48668 0.670522V10.145L1.1458 7.79276C0.884551 7.53029 0.460066 7.52928 0.197536 7.79051C-0.0650053 8.05178 -0.0659275 8.47636 0.195274 8.7388L3.68201 12.2424C3.68221 12.2426 3.68243 12.2428 3.68263 12.243C3.94472 12.5056 4.37064 12.5048 4.63191 12.243H4.63193Z",
          style: { fill: "var(--color-foreground, black)" }
        }
      ) })
    }
  );
};
export {
  Conversation,
  ConversationContent,
  ConversationEmptyState,
  ConversationScrollButton
};
//# sourceMappingURL=conversation.js.map
